module.exports = "//static.hsappstatic.net/signup-ui/static-7.1120/images/content-logo.svg"